import { render, staticRenderFns } from "./NSGRules.vue?vue&type=template&id=494b78ca&scoped=true&"
import script from "./NSGRules.vue?vue&type=script&lang=js&"
export * from "./NSGRules.vue?vue&type=script&lang=js&"
import style0 from "./NSGRules.vue?vue&type=style&index=0&id=494b78ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b78ca",
  null
  
)

export default component.exports